<template>
  <f7-page name="podzemne-vody-chart" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>{{ pageTitle }}</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <template v-if="notEmptyObject(stationDataForChart)">

      <highcharts ref="svtHighcharts1" :updateArgs="[true, true, true]" :options="chartOptions1"></highcharts>
      <highcharts ref="svtHighcharts2" :updateArgs="[true, true, true]" :options="chartOptions2"></highcharts>
      <highcharts ref="svtHighcharts3" :updateArgs="[true, true, true]" :options="chartOptions3"></highcharts>
    </template>

  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts';

import pzvChart1 from './podzemne-vody-chart-options1'
import pzvChart2 from './podzemne-vody-chart-options2'
import pzvChart3 from './podzemne-vody-chart-options3'

Highcharts.setOptions({
  lang: {
    weekdays: ['Nedeľa','Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December']
  },
  global: {
    useUTC: true
  }
});


export default {
  components: {
    highcharts: Chart
  },
  data: function () {
    return {
      pageTitle: 'Sucho v podzemných vodách',
      stationIdForChart: null,
      stationMeta: {},
      stationDataForChart: {},
      chartOptions1: pzvChart1,
      chartOptions2: pzvChart2,
      chartOptions3: pzvChart3,
    };
  },
  watch: {
    stationDataForChart() {
      this.generateChart()
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-vodne-zdroje');
    this.$f7.accordion.open('.shmu-i-vodne-zdroje');
  },
  destroy() {
    clearInterval(this.tCheckInterval);
    this.stationIdForChart = null;
    this.stationDataForChart = {};
  },
  methods: {
    onPageInit() {
      this.stationIdForChart = this.$f7route.params.station_id;
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (this.stationIdForChart && (isInit || (this.$moment().unix() - this.lastUpdated) > 60)) {
        this.loadHistoryData(this.stationIdForChart);
      } else {
        if (!this.stationIdForChart) {
          self.$f7.dialog.alert('Identifikátor stanice nebol správne určený!', 'Nastala chyba');
        }
      }
    },
    loadHistoryData(station_id) {
      const self = this;

      self.$f7.dialog.preloader('Načítavam...');
      Axios.get(SHMUconf.API_BASE_URL + 'pzv/gethistorydata?station='+station_id+'&history=365', {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {
              self.stationDataForChart = response.data;
              self.stationMeta = self.stationDataForChart.station;
              self.pageTitle = self.stationDataForChart.station.station_name + ' - Sucho v podzemných vodách';
              self.lastUpdated = self.$moment().unix();
              // clearInterval(this.tCheckInterval);
              // this.tCheckInterval = setInterval(this.checkLastUpdated, 60 * 60 * 1000); // overujem kazdych 5 min
            } else {
              self.$f7.dialog.alert('Nepodarilo sa načítať údaje pre vykreslenie grafu', 'Nastala chyba');
            }
            self.$f7.dialog.close();
          }).catch((error) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });

    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) >= 30*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    generateChart() {
      // priprav data pre chart
      let vals1 = [];
      let vals_tmp1 = [];
      let dt1 = [];
      let vals3 = [];
      let vals_tmp3 = [];


      // this.chartOptions1.title.text = this.stationMeta.station_name;

      if (this.stationDataForChart.data) {
        this.stationDataForChart.data.forEach((item) => {
          if (this.stationMeta.typ === 1) {
            vals1.push([item.dt * 1000, item.hladina]);
            vals_tmp1.push(item.hladina);
          } else {
            vals1.push([item.dt * 1000, item.hladina_v]);
            vals_tmp1.push(item.hladina_v);
          }
          vals3.push([item.dt * 1000, item.t_vod]);
          vals_tmp3.push(item.t_vod);

          dt1.push(item.dt);
        });
      }

      let z = this.chartOptions1.series.find(item => (item.id) === 'uh');
      z.data = vals1;


      let z2 = this.chartOptions2.series.find(item => (item.id) === 'uh2');
      z2.data = vals1;
      z2.kvantily = this.stationMeta.kvantily;

      let z3 = this.chartOptions3.series.find(item => (item.id) === 'tvod');
      z3.data = vals3;
      //

      if (this.stationMeta.typ === 1) {
        z2.title = z.title = 'Úroveň hladiny PzV (m n.m.)';
        z2.unit = z.unit = ' m n.m.';
        z2.tooltip.valueSuffix = z.tooltip.valueSuffix = ' m n.m.';
      } else {
        z2.title = z.title = 'Výdatnosť prameňa [l.s<sup>-1</sup>]';
        z2.unit = z.unit = ' l.s<sup>-1</sup>';
        z2.tooltip.valueSuffix = z.tooltip.valueSuffix = ' l.s<sup>-1</sup>';
      }
      this.chartOptions1.yAxis.title.text = z.title;
      this.chartOptions2.yAxis.title.text = z.title;

      let min_dt = Math.min.apply(null, dt1);
      let max_dt = Math.max.apply(null, dt1);

      this.chartOptions1.xAxis.max = max_dt*1000 + 15*24*60*60*1000;
      this.chartOptions1.xAxis.min = max_dt*1000 - 365*24*60*60*1000;
      this.chartOptions2.xAxis.max = max_dt*1000 + 15*24*60*60*1000;
      this.chartOptions2.xAxis.min = max_dt*1000 - 365*24*60*60*1000;
      this.chartOptions3.xAxis.max = max_dt*1000 + 15*24*60*60*1000;
      this.chartOptions3.xAxis.min = max_dt*1000 - 365*24*60*60*1000;

      this.chartOptions1.xAxis.plotLines = [];
      this.chartOptions1.yAxis.plotLines = [];

      this.chartOptions2.xAxis.plotLines = [];
      this.chartOptions2.yAxis.plotLines = [];

      this.chartOptions3.xAxis.plotLines = [];
      this.chartOptions3.yAxis.plotLines = [];

      // 1

      let uroven_min = null;
      let uroven_max = null;

      if (this.stationMeta.typ === 1) {
        uroven_min = this.stationMeta.uroven_hladiny_min;
        uroven_max = this.stationMeta.uroven_hladiny_max;
      } else {
        uroven_min = this.stationMeta.min_vydatnost;
        uroven_max = this.stationMeta.max_vydatnost;
      }


      let minVal = null;
      let maxVal = null;
      if (uroven_max) {
        maxVal = uroven_max;
      } else {
        maxVal = Math.max.apply(null, vals_tmp1) + 5;
      }

      if (uroven_min) {
        minVal = uroven_min;
      } else {
        minVal = Math.min.apply(null, vals_tmp1) - 5;
        if (minVal < 0) minVal = 0;
      }

      if (this.stationMeta.id_station === 36) {
        maxVal = Math.max.apply(null, vals_tmp1) + 5;
      }


      this.chartOptions1.yAxis.plotLines.push({ value: 0, color: 'rgba(0, 0, 0, 0.35)', width:2}); // ciara na 0

      if (uroven_min >= 0) {
        this.chartOptions1.yAxis.plotLines.push({
          zIndex: 5, value: uroven_min, color: 'rgba(255, 0, 0, 0.8)', width: 2,
          label: {style: {fontSize: '9px'},
            // text: 'dlhodobé minimum (' + uroven_min + ' ' + z.unit + ')'
            text: ''
          }
        });

        // fake seria pre plotline
        let s = this.chartOptions1.series.find(item => item.id === 'ep_uh_min');
        if (s) {  s.showInLegend = true;
          s.name = 'dlhodobé minimum  (' + uroven_min + ' ' + z.unit + ')';
        }

      } else {
        let s = this.chartOptions1.series.find(item => item.id === 'ep_uh_min');
        if (s) {  s.showInLegend = false; }
      }

      if (uroven_max) {
        this.chartOptions1.yAxis.plotLines.push({
          zIndex: 5, value: uroven_max, color: 'rgba(85, 142, 213, 0.8)', width: 2,
          label: {style: {fontSize: '9px'},
            // text: 'dlhodobé maximum (' + uroven_max + ' ' + z.unit + ')',
            text: ''
          }
        });

        // fake seria pre plotline
        let s = this.chartOptions1.series.find(item => item.id === 'ep_uh_max');
        if (s) {  s.showInLegend = true;
          s.name = 'dlhodobé maximum  (' + uroven_max + ' ' + z.unit + ')';
        }


      } else {
        let s = this.chartOptions1.series.find(item => item.id === 'ep_uh_max');
        if (s) {  s.showInLegend = false; }
      }

      this.chartOptions1.yAxis.max = maxVal + 0.5;
      this.chartOptions1.yAxis.min = minVal - 0.5;

      if (this.stationMeta.dlhodoby_priemer) {
        this.chartOptions1.yAxis.plotLines.push({ zIndex:5, value: this.stationMeta.dlhodoby_priemer, color: 'rgba(0, 176, 80, 0.8)', width:2,
          label:{style:{fontSize:'9px'},
            // text:'dlhodobý priemer  ('+this.stationMeta.dlhodoby_priemer+' ' + z.unit + ')'
            text:''
          }});

        // fake seria pre plotline
        let s = this.chartOptions1.series.find(item => item.id === 'ep_uh_avg');
        if (s) {  s.showInLegend = true;
          s.name = 'dlhodobý priemer  ('+this.stationMeta.dlhodoby_priemer+' ' + z.unit + ')';
        }
      } else {
        let s = this.chartOptions1.series.find(item => item.id === 'ep_uh_avg');
        if (s) {  s.showInLegend = false; }
      }

      if (this.stationMeta.dlhodoby_priemer_81_10) {
        this.chartOptions2.yAxis.plotLines.push({ zIndex:5, value: this.stationMeta.dlhodoby_priemer_81_10, dashStyle: 'ShortDot', color: 'rgb(2,161,69)', width:2,
          label:{style:{fontSize:'9px'},
            // text:'dlhodobý priemer 1981-2010  ('+this.stationMeta.dlhodoby_priemer_81_10+' ' + z.unit + ')'
            text:''
          }});

        // fake seria pre plotline
        let s = this.chartOptions2.series.find(item => item.id === 'ep_uh2_avg');
        if (s) {  s.showInLegend = true;
          s.name = 'dlhodobý priemer 1981-2010  ('+this.stationMeta.dlhodoby_priemer_81_10+' ' + z.unit + ')';
        }

      } else {
        let s = this.chartOptions2.series.find(item => item.id === 'ep_uh2_avg');
        if (s) {  s.showInLegend = false; }
      }

      if (this.stationMeta.dlhodoby_min_81_10) {
        this.chartOptions2.yAxis.plotLines.push({ zIndex:5, value: this.stationMeta.dlhodoby_min_81_10, dashStyle: 'ShortDot', color: 'rgb(193,3,3)', width:2,
          label:{style:{fontSize:'9px'},
            // text:'dlhodobé minimum 1981-2010  ('+this.stationMeta.dlhodoby_min_81_10+' ' + z.unit + ')'
            text:''
          }});

        // fake seria pre plotline
        let s = this.chartOptions2.series.find(item => item.id === 'ep_uh2_min');
        if (s) {  s.showInLegend = true;
          s.name = 'dlhodobé minimum 1981-2010  ('+this.stationMeta.dlhodoby_min_81_10+' ' + z.unit + ')';
        }

      } else {
        let s = this.chartOptions2.series.find(item => item.id === 'ep_uh2_min');
        if (s) {  s.showInLegend = false; }
      }

      if (this.stationMeta.dlhodoby_max_81_10) {
        this.chartOptions2.yAxis.plotLines.push({ zIndex:5, value: this.stationMeta.dlhodoby_max_81_10, dashStyle: 'ShortDot', color: 'rgb(21,107,196)', width:2,
          label:{style:{fontSize:'9px'},
            // text:'dlhodobé maximum 1981-2010  ('+this.stationMeta.dlhodoby_max_81_10+' ' + z.unit + ')'
            text:''
          }});

        if (typeof this.chartOptions2.yAxis.max === 'undefined') {
          this.chartOptions2.yAxis.max = this.stationMeta.dlhodoby_max_81_10 + 1;
        }
        if (this.chartOptions2.yAxis.max < this.stationMeta.dlhodoby_max_81_10) {
          this.chartOptions2.yAxis.max = this.stationMeta.dlhodoby_max_81_10 + 1;
        }

        // fake seria pre plotline
        let s = this.chartOptions2.series.find(item => item.id === 'ep_uh2_max');
        if (s) {  s.showInLegend = true;
          s.name = 'dlhodobé maximum 1981-2010  ('+this.stationMeta.dlhodoby_max_81_10+' ' + z.unit + ')';
        }

      } else {
        let s = this.chartOptions2.series.find(item => item.id === 'ep_uh2_max');
        if (s) {  s.showInLegend = false; }
      }



      if (this.stationMeta.typ === 1 && this.stationMeta.nadm_vyska) {
        this.chartOptions1.yAxis.plotLines.push({
          zIndex:5,  value: this.stationMeta.nadm_vyska,  dashStyle: 'ShortDot',  color: 'rgba(99, 37, 35, 0.8)',
          width:2, label:{style:{fontSize:'9px'}, align:'right',  x:-5,y:12,
            // text:'terén ('+this.stationMeta.nadm_vyska+'m n.m.)'
            text:''
          }
        }); // ciara teren

        this.chartOptions1.yAxis.max = this.stationMeta.nadm_vyska+0.5;

        // fake seria pre plotline
        let s = this.chartOptions1.series.find(item => item.id === 'ep_uh_teren');
        if (s) {  s.showInLegend = true;
          s.name = 'terén ('+this.stationMeta.nadm_vyska+'m n.m.)';
        }

      } else {
        let s = this.chartOptions1.series.find(item => item.id === 'ep_uh_teren');
        if (s) {  s.showInLegend = false; }
      }

      // 2
      let max_y = maxVal;
      let min_y = minVal;
      if (this.stationMeta.min_y) {
        min_y = this.stationMeta.min_y;
      }
      if (this.stationMeta.max_y) {
        max_y = this.stationMeta.max_y;
      }

      if (typeof  this.chartOptions2.yAxis.max !== 'undefined') {
        if (max_y > this.chartOptions2.yAxis.max) {
          this.chartOptions2.yAxis.max = max_y;
        }
      } else {
        this.chartOptions2.yAxis.max = max_y;
      }



      this.chartOptions2.yAxis.min = min_y;
      this.chartOptions2.legend.enabled = true;

      let kvantily_ds = [];
      let kvantily_ds_trans = [];
      let kvantily_lvls = ['f10','f40', 'f60', 'f90', 'f90p'];
      let kvantily = this.stationMeta.kvantily;
      let kvantil_min = null;
      let kvantil_max = null;

      for (let i = this.chartOptions2.xAxis.min; i <= this.chartOptions2.xAxis.max; i += 24*60*60*1000)
      {
        let mesiac = this.$moment.unix(i/1000).format('M') - 1;

        kvantily_lvls.forEach((lvl) => {
          let x_val = null;
          if (kvantily[mesiac][lvl]) {
            x_val = kvantily[mesiac][lvl];
            if (kvantil_min === null) kvantil_min = x_val;
            if (kvantil_max === null) kvantil_max = x_val;
            if (x_val < kvantil_min) kvantil_min = x_val;
            if (x_val > kvantil_max) kvantil_max = x_val;
          }
          if (!kvantily_ds[lvl]) {
            kvantily_ds[lvl] = [];
            kvantily_ds_trans[lvl] = [];
          }
          kvantily_ds[lvl][i] = x_val;
          kvantily_ds_trans[lvl].push([i,x_val]);
        });

      }


      let f10 = this.chartOptions2.series.find(item => (item.id) === 'f10');
      f10.data = kvantily_ds_trans['f10'];
      let f40 = this.chartOptions2.series.find(item => (item.id) === 'f40');
      f40.data = kvantily_ds_trans['f40'];
      let f60 = this.chartOptions2.series.find(item => (item.id) === 'f60');
      f60.data = kvantily_ds_trans['f60'];
      let f90 = this.chartOptions2.series.find(item => (item.id) === 'f90');
      f90.data = kvantily_ds_trans['f90'];


      /*
                      if (empty($station['Min_Y']))
      {
          $min_y = $kvantil_min;
      } else $min_y = $station['Min_Y'];

      if (empty($station['Max_Y']))
      {
          if (isset($uroven_max)) echo $max_y = $uroven_max; else $max_y = max($hladina_vals_arr) + 5;
      } else
      {
          $max_y = $station['Max_Y'];
      }



*/


      // 3

      let min_t = Math.min.apply(null, vals_tmp3);
      let max_t = Math.max.apply(null, vals_tmp3);

      if (this.stationMeta.t_max) {
        max_t = this.stationMeta.t_max;
      }
      if (this.stationMeta.t_min) {
        min_t = this.stationMeta.t_min;
      }

      this.chartOptions3.yAxis.plotLines.push({ value: 0, color: 'rgba(0, 0, 0, 0.35)', width:2}); // ciara na 0

      this.chartOptions3.yAxis.plotLines.push({ zIndex:5, value: min_t, color: 'rgba(217, 2, 2, 0.8)', width:2, label:{style:{fontSize:'9px'},text:'dlhodobá minimálna teplota ('+min_t+'°C)'}});
      this.chartOptions3.yAxis.plotLines.push({ zIndex:5, value: max_t, color: 'rgba(217, 98, 2, 0.8)', width:2, label:{style:{fontSize:'9px'},text:'dlhodobá maximálna teplota ('+max_t+'°C)'}});

      // fake seria pre plotline
      let s2 = this.chartOptions3.series.find(item => item.id === 'ep_tvod_min');
      if (s2) {  s2.showInLegend = true;
        s2.name = 'dlhodobá minimálna teplota ('+min_t+'°C)';
      }

      let s3 = this.chartOptions3.series.find(item => item.id === 'ep_tvod_max');
      if (s3) {  s3.showInLegend = true;
        s3.name = 'dlhodobá maximálna teplota ('+max_t+'°C)';
      }



      this.chartOptions3.yAxis.max = max_t + 1;
      this.chartOptions3.yAxis.min = min_t - 1;




      let mesiac = [];
      for (let i=this.chartOptions1.xAxis.min; i<=this.chartOptions1.xAxis.max;i=i+(24*60*60*1000)) {
        if (new Date(i).getDate()===1) {
          mesiac.push(i)
        }
      }

      mesiac.forEach(dt => {
        this.chartOptions1.xAxis.plotLines.push({ value: dt, color: 'rgba(0, 0, 0, 0.1)', width:1}); // ciara na polnoc
        this.chartOptions2.xAxis.plotLines.push({ value: dt, color: 'rgba(0, 0, 0, 0.1)', width:1, zIndex:150}); // ciara na polnoc
        this.chartOptions3.xAxis.plotLines.push({ value: dt, color: 'rgba(0, 0, 0, 0.1)', width:1}); // ciara na polnoc
      });



    },


  }

};
</script>

